import { Component, Input, OnInit } from '@angular/core';
import { IDashboard } from '../../../types/api-response/auth/dashboard';
import { AuthApiService } from '../../../services/api/auth-api.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AppModalService } from '../../../services/app-modal.service';
import { ModalBaseComponent } from '../../../components/modal-base/modal-base.component';
import { IModalComponent } from '../../../types/modal/modal-base';
import { ModalButton } from '../../../types/modal/modal-button';

declare const toastr: any;

@Component({
    selector: 'dashboard-users-modal',
    templateUrl: './dashboard-users-modal.component.html',
    styleUrls: ['./dashboard-users-modal.component.scss']
})
export class DashboardUsersModalComponent implements OnInit, IModalComponent {

    /**
     * Modal base component
     */
    baseComponent: ModalBaseComponent;

    /**
     * Input modal data
     */
    @Input() data: {dashboard: IDashboard};

    /**
     * Modal title
     */
    @Input() title: string = 'Update users default dashboard';

    /**
     * Modal buttons
     */
    buttons = [
        new ModalButton('Cancel', null, false),
        new ModalButton('Save', this.onSave.bind(this))
    ];

    checkboxUsers: {id: number, checked: boolean, name: string}[] = [];

    isShowSpinner: boolean = false;

    constructor(
        private authApiService: AuthApiService,
        private modalService: AppModalService
    ) {}

    ngOnInit() {
      this.getUsers();
    }

    getUsers() {
        const params: {[key: string]: string|number|Array<string|number>} = {'per-page': 10000};
        if(this.data.dashboard.roles) {
            params.role_id = this.data.dashboard.roles;
        }

        this.isShowSpinner = true;
        this.authApiService.getUsers(params)
            .subscribe(response => {
                this.isShowSpinner = false;
                this.checkboxUsers = response.entities.map(user => {
                    return {
                        id: user.id,
                        checked: +user.defaultDashboardId === +this.data.dashboard.id,
                        name: user.fullName
                    };
                });
            });
    }

    checkAll(checkbox) {
        this.checkboxUsers.map(user => user.checked = checkbox.checked);
    }

    onSave() {
        const tasks$ = this.checkboxUsers.filter(user => user.checked).map(user => this.authApiService.setDefaultUserDashboard(user.id, this.data.dashboard.id));
        forkJoin(tasks$).subscribe(result => {
            toastr.success('Default dashboard updated for selected users');
            this.modalService.close();
        });
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/dashboard/dashboard-users-modal/dashboard-users-modal.component.ts